export default function merge(...objects) {
  return objects.reduce((prev, obj) => {
    const result = prev;

    Object.keys(obj).forEach(key => {
      if (typeof prev[key] === 'object' && typeof obj[key] === 'object') {
        result[key] = merge(prev[key], obj[key]);
      } else {
        result[key] = obj[key];
      }
    });

    return result;
  }, {});
}
